import at from '../actionTypes'
import createReducer from './utilities/createReducer'
import getCurrentUid from '../../utilities/getCurrentUid'

export default createReducer({}, {
	[at.postCommentsFetch_Begin]: state => ({
		...state,
		postComments: undefined
	}),

	[at.postCommentsFetch_Success]: (state, action) => ({
		...state,
		postComments: action.payload.postComments,
		post: action.payload.post
	}),

	//	Optimistically add post comment
	[at.postCommentAdd_Success]: (state, action) => {
		const timestamp = (new Date()).getTime()
		const addedComment = { ...action.payload.comment, uid: getCurrentUid(), createdTimestamp: timestamp, modifiedTimestamp: timestamp }
		return {
			...state,
			postComments: [...(state.postComments ? [...state.postComments, addedComment] : [addedComment])],
			postCommentDraft: { text: '' }
		}
	},

	//	Optimistically delete post comment
	[at.postCommentDelete_Begin]: (state, action) => ({
		...state,
		postComments: [...(state.postComments ? [...state.postComments.filter(c => c.commentId !== action.payload.commentId)] : [])]
	}),

	//	Optimistically delete post comment (admin)
	[at.postCommentDeleteByPostOwner_Begin]: (state, action) => ({
		...state,
		postComments: [...(state.postComments ? [...state.postComments.filter(c => c.commentId !== action.payload.commentId)] : [])]
	})
})



// WEBPACK FOOTER //
// ./src/redux/reducers/commentReducer.js